/*!
  * imin-printer v2.0.3
  * (c) 2024 archiesong
  * @license MIT
  */
var t, e;
t = this, e = function () {
    "use strict";
    var t, e, n, i, o, r = function (e) {
        if ("object" != typeof e) {
            if (r.installed && t === e) return;
            r.installed = !0, t = e;
            var n = function (t) {
                return void 0 !== t
            }, i = function (t, e) {
                var i = t.$options._parentVnode;
                n(i) && n(i = i.data) && n(i = i.registerPrinterInstance) && i(t, e)
            };
            return e.mixin({
                beforeCreate: function () {
                    this.print || (this.print = {}), n(this.$options.printer) ? (this._printerRoot = this, this._printer = this.$options.printer) : this._printerRoot = this.$parent && this.$parent._printerRoot || this, i(this, this)
                }, destroyed: function () {
                    i(this, void 0)
                }
            }), void Object.defineProperty(e.prototype, "$printer", {
                get: function () {
                    return this._printerRoot._printer
                }
            })
        }
        var o = function (t) {
            return void 0 !== t
        }, s = function (t, e) {
            var n = t.$options._parentVnode;
            o(n) && o(n = n.data) && o(n = n.registerPrinterInstance) && n(t, e)
        };
        e.mixin({
            beforeCreate: function () {
                this.print || (this.print = {}), o(this.$options.printer) ? (this._printerRoot = this, this._printer = this.$options.printer) : this._printerRoot = this.$parent && this.$parent._printerRoot || this, s(this, this)
            }, destroyed: function () {
                s(this, void 0)
            }
        })
    };
    !function (t) {
        t.USB = "USB", t.SPI = "SPI", t.Bluetooth = "Bluetooth"
    }(e || (e = {})), function (t) {
        t.NORMAL = "0", t.OPEN = "3", t.NOPAPERFEED = "7", t.PAPERRUNNINGOUT = "8", t.NOTCONNECTED = "-1", t.NOTPOWEREDON = "1", t.OTHERERRORS = "99"
    }(n || (n = {})), function (t) {
        t.WEBSOCKET_WS = "ws://", t.WEBSOCKET_WSS = "wss://", t.HTTP = "http://", t.HTTPS = "https://"
    }(i || (i = {})), function (t) {
        t.WEBSOCKET = "/websocket", t.HTTP = "/upload"
    }(o || (o = {}));
    var s = function (t) {
        return JSON.parse(t)
    }, a = function (t) {
        var e = "";
        e = t.split(",")[0].indexOf("base64") >= 0 ? window.atob(t.split(",")[1]) : decodeURIComponent(t.split(",")[1]);
        for (var n = t.split(",")[0].split(":")[1].split(";")[0], i = new Uint8Array(e.length), o = 0; o < e.length; o++) i[o] = e.charCodeAt(o);
        return new window.Blob([i], {type: n})
    }, c = function (t) {
        var e = "The printer is not connected or powered on";
        switch (t.toString()) {
            case"0":
                e = "The printer is normal";
                break;
            case"3":
                e = "Print head open";
                break;
            case"7":
                e = "No Paper Feed";
                break;
            case"8":
                e = "Paper Running Out";
                break;
            case"99":
                e = "Other errors";
                break;
            default:
                e = "The printer is not connected or powered on"
        }
        return e
    }, d = "undefined" != typeof window, p = function (t) {
        this.address = t || "127.0.0.1", this.lock_time = 4e3, this.check_time = 3e3, this.heart_time = 3e3, this.port = 8081, this.isLock = !1, this.callback = function () {
        }, this.prefix = o.WEBSOCKET, this.protocol = i.WEBSOCKET_WS
    };
    p.prototype.connect = function () {
        var t = this;
        return new Promise((function (e, n) {
            var i = window.MozWebSocket || window.WebSocket;
            i || n(function (t, e) {
                if (!t) throw new Error("[imin-printer] " + e)
            }(i, "Browser does not support Websocket!"));
            try {
                var o = new i("" + t.protocol + t.address + ":" + t.port + t.prefix);
                o.onopen = function (i) {
                    t.heartCheck(), o.readyState === o.OPEN ? e(!0) : n()
                }, o.onclose = function (e) {
                    t.reconnect()
                }, o.onerror = function () {
                    t.reconnect()
                }, o.onmessage = function (e) {
                    "request" === e.data || s(e.data) && 0 === s(e.data).type ? t.heartCheck() : t.callback(s(e.data))
                }, t.ws = o
            } catch (e) {
                t.reconnect(), n(e)
            }
        }))
    }, p.prototype.sendParameter = function (t, e, n, i) {
        return function (t) {
            return JSON.stringify(t)
        }({
            data: Object.assign({}, {text: void 0 !== t ? t : "", value: void 0 !== n ? n : -1}, i || {}),
            type: void 0 !== e ? e : 0
        })
    }, p.prototype.heartCheck = function () {
        var t = this;
        this.h_timer && clearTimeout(this.h_timer), this.c_timer && clearTimeout(this.c_timer), this.h_timer = setTimeout((function () {
            t.send(t.sendParameter("ping")), t.c_timer = setTimeout((function () {
                1 !== t.ws.readyState && t.close()
            }), t.check_time)
        }), this.heart_time)
    }, p.prototype.reconnect = function () {
        var t = this;
        this.isLock || (this.isLock = !0, this.l_timer && clearTimeout(this.l_timer), this.l_timer = setTimeout((function () {
            t.connect(), t.isLock = !1
        }), this.lock_time))
    }, p.prototype.send = function (t) {
        this.ws.send(t)
    }, p.prototype.close = function () {
        this.ws && (this.ws.close(), this.ws = null)
    };
    var h = function (t) {
        function n(n) {
            t.call(this, n), this.connect_type = e.SPI
        }

        return t && (n.__proto__ = t), n.prototype = Object.create(t && t.prototype), n.prototype.constructor = n, n.prototype.initPrinter = function (t) {
            void 0 === t && (t = e.SPI), this.connect_type = t, this.send(this.sendParameter(t, 1))
        }, n.prototype.getPrinterStatus = function (t) {
            var n = this;
            return void 0 === t && (t = e.SPI), new Promise((function (e) {
                n.connect_type = t, n.send(n.sendParameter(t, 2)), n.callback = function (t) {
                    2 === t.type && e(Object.assign({}, t.data, {text: c(t.data.value)}))
                }
            }))
        }, n.prototype.printAndLineFeed = function (t) {
            this.send(this.sendParameter("", 3))
        }, n.prototype.partialCut = function () {
            this.send(this.sendParameter("", 5))
        }, n.prototype.printAndFeedPaper = function (t) {
            this.send(this.sendParameter("", 4, t <= 0 ? 0 : t >= 255 ? 255 : t))
        }, n.prototype.setAlignment = function (t) {
            this.send(this.sendParameter("", 6, t <= 0 ? 0 : t >= 2 ? 2 : t))
        }, n.prototype.setTextSize = function (t) {
            this.send(this.sendParameter("", 7, t))
        }, n.prototype.setTextTypeface = function (t) {
            this.send(this.sendParameter("", 8, t))
        }, n.prototype.setTextStyle = function (t) {
            this.send(this.sendParameter("", 9, t <= 0 ? 0 : t >= 3 ? 3 : t))
        }, n.prototype.setTextLineSpacing = function (t) {
            this.send(this.sendParameter("", 10, t))
        }, n.prototype.setTextWidth = function (t) {
            this.send(this.sendParameter("", 11, t <= 0 ? 0 : t >= 576 ? 576 : t))
        }, n.prototype.printText = function (t, e) {
            this.send(this.sendParameter(void 0 === e || e || "n" !== t.charAt(t.length - 1) ? void 0 !== e ? t : t + "\n" : t.slice(0, t.length - 1) + "\n", void 0 !== e ? 13 : 12, void 0 !== e ? e <= 0 ? 0 : e >= 1 ? 1 : e : void 0))
        }, n.prototype.printColumnsText = function (t, e, n, i, o) {
            this.send(this.sendParameter("", 14, o < 0 ? 0 : o > 576 ? 576 : o, {
                colTextArr: t,
                colWidthArr: e,
                colAlign: n.map((function (t) {
                    return t <= 0 ? 0 : t >= 2 ? 2 : t
                })),
                size: i
            }))
        }, n.prototype.setBarCodeWidth = function (t) {
            this.send(this.sendParameter("", 15, void 0 !== t ? t <= 2 ? 2 : t >= 6 ? 6 : t : 3))
        }, n.prototype.setBarCodeHeight = function (t) {
            this.send(this.sendParameter("", 16, t <= 1 ? 1 : t >= 255 ? 255 : t))
        }, n.prototype.setBarCodeContentPrintPos = function (t) {
            this.send(this.sendParameter("", 17, t <= 0 ? 0 : t >= 3 ? 3 : t))
        }, n.prototype.printBarCode = function (t, e, n) {
            this.send(this.sendParameter(e, void 0 !== n ? 19 : 18, Number(t) <= 0 ? 0 : Number(t) >= 6 && 73 !== Number(t) && 8 !== Number(t) ? 6 : Number(t), void 0 !== n ? {alignmentMode: n <= 0 ? 0 : n >= 2 ? 2 : n} : {}))
        }, n.prototype.setQrCodeSize = function (t) {
            this.send(this.sendParameter("", 20, t <= 1 ? 1 : t >= 13 ? 13 : t))
        }, n.prototype.setQrCodeErrorCorrectionLev = function (t) {
            this.send(this.sendParameter("", 21, t <= 48 ? 48 : t >= 51 ? 51 : t))
        }, n.prototype.setLeftMargin = function (t) {
            this.send(this.sendParameter("", 22, t <= 0 ? 0 : t >= 576 ? 576 : t))
        }, n.prototype.printQrCode = function (t, e) {
            this.send(this.sendParameter(t, void 0 !== e ? 24 : 23, void 0 !== e ? e <= 0 ? 0 : e >= 2 ? 2 : e : void 0))
        }, n.prototype.setPageFormat = function (t) {
            this.send(this.sendParameter("", 25, t >= 1 ? 1 : 0))
        }, n.prototype.openCashBox = function () {
            this.send(this.sendParameter("", 100))
        }, n.prototype.printSingleBitmap = function (t, e) {
            var n = this;
            return new Promise((function (r) {
                if ("[object Object]" !== Object.prototype.toString.call(t)) {
                    var s = new window.Image;
                    /^\s*data:([a-z]+\/[a-z0-9-+.]+(;[a-z-]+=[a-z0-9-]+)?)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@\/?%\s]*?)\s*$/i.test(t) ? s.src = t : (s.crossOrigin = "*", s.src = t + "?v=" + (new Date).getTime()), s.onload = function () {
                        var r, c, d, p, h, u, f = new window.FormData;
                        f.append("file", a((r = s, c = a(t).type, d = document.createElement("canvas"), p = d.getContext("2d"), h = r.width, u = r.height, d.width = h, d.height = u, p.clearRect(0, 0, h, u), p.drawImage(r, 0, 0, h, u), d.toDataURL(c || "image/png"))));
                        var l = null;
                        (l = window.XMLHttpRequest ? new XMLHttpRequest : window.ActiveXObject ? new window.ActiveXObject("Microsoft.XMLHTTP") : null) && (l.open("POST", "" + i.HTTP + n.address + ":" + n.port + o.HTTP), l.onreadystatechange = function () {
                            4 === l.readyState && 200 === l.status && (l.responseText && n.send(n.sendParameter("", void 0 !== e ? 27 : 26, void 0 !== e ? e : void 0)), l = null)
                        }, l.send(f))
                    }
                } else {
                    var c = new window.FormData;
                    c.append("file", t);
                    var d = null;
                    (d = window.XMLHttpRequest ? new XMLHttpRequest : window.ActiveXObject ? new window.ActiveXObject("Microsoft.XMLHTTP") : null) && (d.open("POST", "" + i.HTTP + n.address + ":" + n.port + o.HTTP), d.onreadystatechange = function () {
                        4 === d.readyState && 200 === d.status && (d.responseText && n.send(n.sendParameter("", void 0 !== e ? 27 : 26, void 0 !== e ? e : void 0)), d = null)
                    }, d.send(c))
                }
                n.callback = function (t) {
                    [27, 26].includes(t.type) && r()
                }
            }))
        }, n.prototype.setDoubleQRSize = function (t) {
            this.send(this.sendParameter("", 28, t))
        }, n.prototype.setDoubleQR1Level = function (t) {
            this.send(this.sendParameter("", 29, t <= 1 ? 1 : t >= 3 ? 3 : t))
        }, n.prototype.setDoubleQR2Level = function (t) {
            this.send(this.sendParameter("", 30, t <= 1 ? 1 : t >= 3 ? 3 : t))
        }, n.prototype.setDoubleQR1MarginLeft = function (t) {
            this.send(this.sendParameter("", 31, t <= 0 ? 0 : t >= 200 ? 200 : t))
        }, n.prototype.setDoubleQR2MarginLeft = function (t) {
            this.send(this.sendParameter("", 32, t <= 0 ? 0 : t >= 200 ? 200 : t))
        }, n.prototype.setDoubleQR1Version = function (t) {
            this.send(this.sendParameter("", 33, t <= 0 ? 0 : t >= 40 ? 40 : t))
        }, n.prototype.setDoubleQR2Version = function (t) {
            this.send(this.sendParameter("", 34, t <= 0 ? 0 : t >= 40 ? 40 : t))
        }, n.prototype.printDoubleQR = function (t) {
            this.send(this.sendParameter("", 35, void 0, {colTextArr: t}))
        }, n.prototype.electronicScaleRemovePeel = function () {
            this.send(this.sendParameter("", 1001))
        }, n.prototype.electronicScaleTurnZero = function () {
            this.send(this.sendParameter("", 1002))
        }, n.prototype.electronicScaleGetWeight = function (t) {
            this.send(this.sendParameter("", 1003)), this.callback = function (e) {
                1003 === e.type && t && t(Object.assign({}, e.data))
            }
        }, n.prototype.closeElectronicScale = function () {
            this.send(this.sendParameter("", 1004))
        }, n.prototype.getPrinterPaperDistance = function () {
            var t = this;
            return new Promise((function (e) {
                t.send(t.sendParameter("", 90)), t.callback = function (t) {
                    90 === t.type && e(Object.assign({}, t.data))
                }
            }))
        }, n.prototype.getPrinterCutTimes = function () {
            var t = this;
            return new Promise((function (e) {
                t.send(t.sendParameter("", 91)), t.callback = function (t) {
                    91 === t.type && e(Object.assign({}, t.data))
                }
            }))
        }, n.prototype.partialCutPaper = function () {
            this.send(this.sendParameter("", 36))
        }, n
    }(p);
    return h.install = r, h.version = "2.0.3", d && window.Vue && window.Vue.use(h), h
}, "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = "undefined" != typeof globalThis ? globalThis : t || self).IminPrinter = e();